import ReactDOM from "react-dom";
import { useDispatch } from "react-redux";
import { closeModal } from "../../actions/ui";
import { images } from "../../constants";

import "./Modal.scss";

const Modal = ({ children, action, clean }) => {
  const dispatch = useDispatch();

  const handleCloseModal = () => {
    if(clean) {
      dispatch(clean())
    }
    
    dispatch(closeModal());
  };
  return ReactDOM.createPortal(
    <div className="modal__content">

      <div className="modalwrapper">
        <div className="modal__heading">
          <button onClick={handleCloseModal}>
            <img src={images.IconCloseModal} alt="" />
          </button>
        </div>

        <div className="modal__component">
          <div className="modal__component--wrapper">{children}</div>
        </div>
      </div>

      
    </div>,

    document.getElementById("modal")
  );
};

export default Modal;
